(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.timers = [];
    }
    
    connectedCallback() {
      this.setHeaderHeight();
      this.initTimers();
    }
    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--announcement-bar-height', `${document.querySelector('announcement-bar .utility-bar__grid').offsetHeight}px`);
      setTimeout(() => {
        document.documentElement.style.setProperty('--announcement-bar-height', `${document.querySelector('announcement-bar .utility-bar__grid').offsetHeight}px`);
      }, 50);
    }
    
    initTimers() {
      const timerElements = this.querySelectorAll('.countdown-timer');
      
      timerElements.forEach((timer) => {
        const dateStr = timer.getAttribute('data-timer-date');
        if (!dateStr) return;
        
        const targetDate = new Date(dateStr).getTime();
        
        if (isNaN(targetDate)) {
          timer.textContent = dateStr;
          return;
        }
        
        const pad = (num) => String(num).padStart(2, '0');
        
        const updateTimer = () => {
          const now = new Date().getTime();
          const distance = targetDate - now;
          
          if (distance < 0) {
            timer.innerHTML = '<span>00D</span>:<span>00H</span>:<span>00M</span>:<span>00S</span>';
            return;
          }
          
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          timer.innerHTML = '<span>' + pad(days) + 'D</span>:<span>' + pad(hours) + 'H</span>:<span>' + pad(minutes) + 'M</span>:<span>' + pad(seconds) + 'S</span>';
        };
        
        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        this.timers.push(interval);
      });
    }
    
    disconnectedCallback() {
      this.timers.forEach(interval => clearInterval(interval));
      this.timers = [];
    }
  }
  
  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);
  
  class NormalHeaderStickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight();
    }
    
    setHeaderHeight() {
      this.header = document.querySelector('.section-header');
      // console.log('NormalHeaderStickyHeader',this);
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

  }
  
  customElements.define('static-header', NormalHeaderStickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-vertical-tab"]) return;
  try {
     
  const tabTitle = document.querySelectorAll('.rte .tab-content h2');
  const tabTitleContainer = document.querySelector('.anchor-container');
  const ulElement = document.createElement('ul');
  tabTitle.forEach((element, index) => {
    element.setAttribute('id', `content-${index+1}`);
    element.classList.add('scroll-margin');
    const liElement = document.createElement('li');
    
    const button = document.createElement('button');
    button.textContent = element.textContent;
    if(index == 0){
      button.className = 'tab-link button active';
    }else{
      button.className = 'tab-link button';
    }
    button.setAttribute('data-content', `content-${index+1}`);

    liElement.appendChild(button);
    ulElement.appendChild(liElement);

    button.addEventListener('click', () => {
      tabTitleContainer.querySelectorAll('button').forEach((button) => {
        button.classList.remove('active');
      });
      button.classList.add('active');
      document.querySelector(`#content-${index+1}`).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
  tabTitleContainer.appendChild(ulElement);

  } catch(e) { console.error(e); }
})();
})();
